// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"804":"f0d49a55","981":"99925045"}[chunkId] + ".chunk.js";
};